/**
 * Retourne le numéro de téléphone formatté
 * @param {string} numeroTelephone
 */

const formatNumeroTelephone = function (numeroTelephone) {
  return numeroTelephone.replace(/\B(?=(\d{2})+(?!\d))/g, ' ')
}

const isEmptyString = function (string) {
  return string != null && string.trim() === ''
}

export {
  formatNumeroTelephone,
  isEmptyString
}
